'use client';

import type { ReactNode } from 'react';

export type QuestionsForUserPanelProps = {
  // "### Questions for User" 섹션 본문 마크다운. 표시할 질문이 없으면 null이라 아무것도 렌더하지 않는다.
  markdown: string | null;
  /** 마크다운 렌더러. 호스트가 공급한다(공용 패키지는 마크다운 뷰어를 소유하지 않는다). */
  renderMarkdown: (content: string) => ReactNode;
};

export default function QuestionsForUserPanel({ markdown, renderMarkdown }: QuestionsForUserPanelProps) {
  if (!markdown) {
    return null;
  }

  return (
    <div className="rounded-lg border border-base-300 bg-base-200 p-3 text-xs text-base-content/80">
      <p className="mb-1.5 font-semibold uppercase tracking-wider text-[var(--color-fg-subtle)]">Questions for User</p>
      {/* 좁은 패널에 들어가는 블록이라 prose 기본 크기를 text-xs로 낮추고 첫/마지막 여백을 없앤다. */}
      <div className="[&_.prose]:!max-w-none [&_.prose]:!text-xs [&_.prose]:!text-base-content/80 [&_.prose_code]:break-all [&_.prose_li]:!text-xs [&_.prose_p]:!text-xs [&_.prose_pre]:overflow-x-auto [&_.prose>*:first-child]:!mt-0 [&_.prose>*:last-child]:!mb-0">
        {renderMarkdown(markdown)}
      </div>
    </div>
  );
}
